import { render, staticRenderFns } from "./AssessmentDefectGroupSelector.vue?vue&type=template&id=038a0e9e&scoped=true&"
import script from "./AssessmentDefectGroupSelector.vue?vue&type=script&lang=js&"
export * from "./AssessmentDefectGroupSelector.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentDefectGroupSelector.vue?vue&type=style&index=0&id=038a0e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a0e9e",
  null
  
)

export default component.exports